///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { combineReducers } from "@reduxjs/toolkit";

import { coveredRoutesReducer } from "./slices/coveredRoutesSlice";
import { filtersReducer } from "./slices/filtersSlice";
import { serviceLevelsReducer } from "./slices/serviceLevelsSlice";
import { carrierReducer } from "./slices/carrierSlice";
import { facilitiesReducer } from "./slices/facilitiesSlice";
import { legsReducer } from "./slices/legsSlice";
import { legTrailersReducer } from "./slices/legTrailersSlice";
import { carriersReducer } from "./slices/carriersSlice";
import { carrierManagementReducer } from "./slices/carrierManagementSlice";
import { spotLegsReducer } from "./slices/spotLegsSlice";
import { spotLegReducer } from "./slices/spotLegSlice";
import { spotFiltersReducer } from "./slices/spotFiltersSlice";
import { goTrackUserReducer } from "./slices/goTrackUserSlice";
import { errorHandlingReducer } from "./slices/errorHandlingSlice";
import { adHocReducer } from "./slices/adHocSlice";
import { goTrackUserSearchReducer } from "./slices/goTrackUserSearchSlice";
import { updateSpotLegReducer } from "./slices/updateSpotLegSlice";
import { notesReducer } from "./slices/notesSlice";
import { spotNotesReducer } from "./slices/spotNotesSlice";
import { userPermissionsReducer } from "./slices/userPermissionsSlice";
import { featureFlagsReducer } from "./slices/featureFlagsSlice";
import { userManagementReducer } from "./slices/userManagementSlice";
import { userManagementFiltersReducer } from "./slices/userManagementFiltersSlice";
import { userReducer } from "./slices/userSlice";
import { organizationsReducer } from "./slices/organizationsSlice";
import { carrierManagementFiltersReducer } from "./slices/carrierManagementFiltersSlice";

const rootReducer = combineReducers({
  coveredRoutes: coveredRoutesReducer,
  filters: filtersReducer,
  serviceLevels: serviceLevelsReducer,
  carrier: carrierReducer,
  facilities: facilitiesReducer,
  legs: legsReducer,
  legTrailers: legTrailersReducer,
  carriers: carriersReducer,
  spotLegs: spotLegsReducer,
  spotLegDetails: spotLegReducer,
  spotFilters: spotFiltersReducer,
  goTrackUser: goTrackUserReducer,
  errorHandling: errorHandlingReducer,
  adHoc: adHocReducer,
  goTrackUserSearch: goTrackUserSearchReducer,
  updateSpotLeg: updateSpotLegReducer,
  notes: notesReducer,
  spotNotes: spotNotesReducer,
  carrierManagementCarriers: carrierManagementReducer,
  userPermissions: userPermissionsReducer,
  featureFlags: featureFlagsReducer,
  userManagementUsers: userManagementReducer,
  userManagementFilters: userManagementFiltersReducer,
  user: userReducer,
  organizations: organizationsReducer,
  carrierManagementFilters: carrierManagementFiltersReducer,
});

export default rootReducer;
